import React from 'react';
import type { ClingPlayMode } from '../../lib/melody/clingCantaConfig';
import type { ClingGameState } from '../../lib/melody/clingCantaEngine';
import type { ExploreGameState } from '../../lib/melody/clingExploreEngine';
import { exploreCollectedCount } from '../../lib/melody/clingExploreEngine';

interface ClingCantaResultsProps {
  mode: ClingPlayMode;
  cantoGame?: ClingGameState;
  exploreGame?: ExploreGameState;
  onRetry: () => void;
  onLobby: () => void;
}

export const ClingCantaResults: React.FC<ClingCantaResultsProps> = ({
  mode,
  cantoGame,
  exploreGame,
  onRetry,
  onLobby,
}) => {
  if (mode === 'exploracion' && exploreGame) {
    const collected = exploreCollectedCount(exploreGame);
    const total = exploreGame.items.length;
    const passed = collected >= Math.ceil(total * 0.6);

    return (
      <div className="cling-canta-results flex flex-col flex-1 min-h-0 items-center justify-center gap-4 p-4 text-center">
        <p className="text-5xl" aria-hidden>
          {passed ? '🌟' : '💪'}
        </p>
        <h2 className="junior-display text-2xl text-[#1e4976]">
          {passed ? '¡Exploración completada!' : '¡Casi! Sigue explorando'}
        </h2>
        <div className="cling-canta-results-grid">
          <div>
            <span>Recogidos</span>
            <strong>
              {collected}/{total}
            </strong>
          </div>
          <div>
            <span>Puntos</span>
            <strong>{exploreGame.score}</strong>
          </div>
        </div>
        <div className="flex flex-col sm:flex-row gap-2 w-full max-w-sm">
          <button type="button" onClick={onRetry} className="cling-canta-btn cling-canta-btn--primary flex-1">
            ↻ Otra vez
          </button>
          <button type="button" onClick={onLobby} className="cling-canta-btn cling-canta-btn--secondary flex-1">
            Elegir modo
          </button>
        </div>
      </div>
    );
  }

  const game = cantoGame!;
  const total = game.hits + game.misses;
  const accuracy = total > 0 ? Math.round((game.hits / total) * 100) : 0;
  const passed = accuracy >= 60;

  return (
    <div className="cling-canta-results flex flex-col flex-1 min-h-0 items-center justify-center gap-4 p-4 text-center">
      <p className="text-5xl" aria-hidden>
        {passed ? '🌟' : '💪'}
      </p>
      <h2 className="junior-display text-2xl text-[#1e4976]">
        {passed ? '¡Muy bien cantado!' : '¡Sigue practicando!'}
      </h2>
      <div className="cling-canta-results-grid">
        <div>
          <span>Puntos</span>
          <strong>{game.score}</strong>
        </div>
        <div>
          <span>Aciertos</span>
          <strong>{game.hits}</strong>
        </div>
        <div>
          <span>Precisión</span>
          <strong>{accuracy}%</strong>
        </div>
        <div>
          <span>Mejor combo</span>
          <strong>×{game.maxCombo}</strong>
        </div>
      </div>
      <div className="flex flex-col sm:flex-row gap-2 w-full max-w-sm">
        <button type="button" onClick={onRetry} className="cling-canta-btn cling-canta-btn--primary flex-1">
          ↻ Otra vez
        </button>
        <button type="button" onClick={onLobby} className="cling-canta-btn cling-canta-btn--secondary flex-1">
          Elegir modo
        </button>
      </div>
    </div>
  );
};

export default ClingCantaResults;
